import styled, { css } from 'styled-components';

export const Wrapper = styled.div``;
export const RadioGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: ${({ theme }) => `0 -${theme.spacing.x6}`};
`;
export const RadioWrapper = styled.div<{ $checked: boolean }>`
  display: flex;
  align-items: center;
  margin: 0 ${({ theme }) => `${theme.spacing.x6}`};
  cursor: ${({ $checked }) => ($checked ? 'default' : 'pointer')};
`;
export const Radio = styled.div<{ $checked: boolean }>`
  width: ${({ theme }) => theme.spacing.x6};
  height: ${({ theme }) => theme.spacing.x6};
  border-radius: ${({ theme }) => theme.rounded.full};
  padding: ${({ theme }) => theme.spacing.x1};
  border: 2px solid ${({ theme, $checked }) => ($checked ? theme.palette.secondary : theme.palette.border)};
  background: #fff;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  &:after {
    content: '';
    width: 100%;
    height: 100%;
    ${({ $checked, theme }) =>
      $checked
        ? css`
            background: ${theme.palette.secondary};
          `
        : null};
    border-radius: inherit;
  }
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.palette.primary};
  font-size: ${({ theme }) => theme.fs.sm};
  font-weight: 500;
  margin-inline-start: ${({ theme }) => theme.spacing.x2};
  cursor: pointer;
`;

// export default styled.div`
//   ${({ theme: { space } }) => css`
//     label {
//       display: flex;
//       align-items: center;
//       margin-inline-end: ${space.md};

//       input {
//         margin-inline-end: ${space.xs};
//       }
//     }
//   `}
// `;
